import { useQuery } from '@tanstack/react-query'

import { getAvailableIntegrations } from '../api'
import { integrationsKeys } from '../queryKeys'

const useGetAvailableIntegrationsQuery = (isEnabled: boolean = true) => {
  const getIntegrationsQuery = useQuery(
    integrationsKeys.list(),
    getAvailableIntegrations,
    { enabled: isEnabled }
  )
  return getIntegrationsQuery
}

export default useGetAvailableIntegrationsQuery
